<template>
  <footer class="br-t-1px br-grey-transp-20 pd-t-big pd-b-big">
    <div class="pd-l-medium pd-r-medium flex flex-column gap-small mobile:gap-small">
      <div class="flex flex-wrap mobile:flex-column gap-thin mobile:gap-small p-small t-grey">
        <span>&copy; {{ new Date().getFullYear() }} traffers.ru</span>
        <span class="desktop-only">·</span>
        <span>ИНН 450143403226</span>
      </div>
      <nav class="flex flex-wrap mobile:flex-column gap-medium mobile:gap-small">
        <router-link to="/legal/cookie" class="p-small t-grey hover:t-main">Использование cookie</router-link>
        <router-link to="/legal/offer" class="p-small t-grey hover:t-main">Оферта на оказание услуг</router-link>
        <router-link to="/legal/privacy-policy" class="p-small t-grey hover:t-main">Политика конфиденциальности</router-link>
        <router-link to="/legal/personal-data" class="p-small t-grey hover:t-main">Обработка персональных данных</router-link>
      </nav>
    </div>
  </footer>
</template>

<script setup>
</script>
